import React, { useRef } from 'react'
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials'
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage'
import ContactHelp from '../molecules/ContactHelp/ContactHelp'
import Footer from '../organisms/Footer/Footer'
import { getPageData, useData } from '../../app/helper/functions'
import EccProjectContent from '../organisms/ProjectsList/EccProject/EccprojectContent'
import EccProjectOverview from '../organisms/ProjectsList/EccProject/EccprojectOverview'
import { motion } from 'framer-motion'

const ECCPage = () => {
    const { loading, data, error } = useData();
    const ECCPageData = getPageData(data, 'eccProjectPage');
    
    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };
    
    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3
            }
        }
    };
    
    // Scroll references
    const bannerRef = useRef(null);
    const contentRef = useRef(null);
    const overviewRef = useRef(null);
    const testimonialsRef = useRef(null);
    const logoRef = useRef(null);
    const contactRef = useRef(null);
    
    return (
        <div>
            <motion.div 
                ref={bannerRef}
                className='bg-ecc-banner bg-center bg-cover bg-no-repeat'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { duration: 0.8 } }
                }}
            >
                <div className=''>
                    <div className='flex justify-center items-center gap-4 px-4 md:pr-16 pt-32 md:pt-52 pb-10'>
                        <motion.div 
                            className='text-white flex flex-col gap-2 relative pl-0 md:pl-[9%] text-center'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.5 }}
                            variants={staggerContainer}
                        >
                            <motion.div variants={fadeInUp} className='capitalize font-bold text-4xl md:text-6xl'>ECC Website</motion.div>
                            <motion.div variants={fadeInUp} className='font-medium text-xl md:text-2xl'>Optimizing patient care: How we developed a website<br className='hidden md:block' />
                                for excellent care clinics</motion.div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    ref={contentRef}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                    variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                    }}
                >
                    <EccProjectContent ECCPageData={ECCPageData}/>
                </motion.div>
                
                <motion.div
                    ref={overviewRef}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                    variants={{
                        hidden: { opacity: 0.6, y: 20 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                    }}
                >
                    <EccProjectOverview />
                </motion.div>
                
                <motion.div
                    ref={testimonialsRef}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                    variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                    }}
                >
                    <AppsTestimonials color='#3560ca' bgcolor={'bg-eccColor'} />
                </motion.div>
                
                <motion.div
                    ref={logoRef}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                    variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                    }}
                    className='p-4 md:p-10 md:px-36'
                >
                    <CompanyLogoImage />
                </motion.div>
                
                <motion.div
                    ref={contactRef}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.1 }}
                    variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                    }}
                >
                    <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
                </motion.div>
                
                <Footer />
            </div>
        </div>
    )
}

export default ECCPage
